import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

const BrandsSchemasHelmet = ({
  brandsSchema
}) =>
  <Helmet>
    <script type="application/ld+json">
      {brandsSchema}
    </script>
  </Helmet>


BrandsSchemasHelmet.propTypes = {
  brandsSchema: PropTypes.string
}

export default BrandsSchemasHelmet
